const subscriptionTiers = ['SAAS LITE', 'ENTERPRISE', 'FULL SERVICE', 'LEGACY DONATION'];
export default subscriptionTiers;
